/* src/app/csm-report/csm-report.component.scss */
.csm-report {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  align-items: stretch;
  margin-top: 50px;
}
.csm-report .report-name {
  font-size: 1.5rem;
}
.csm-report .type-selector {
  max-width: 300px;
  padding: 5px;
}
.csm-report .opposite {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
}
.csm-report .toolbar {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  flex-shrink: 0;
}
.csm-report .toolbar button {
  margin-left: 10px;
}
.csm-report .table-container {
  flex: 1 1 auto;
  overflow: auto;
  width: 100%;
  margin-top: 10px;
  min-height: 0;
}
.csm-report .table-container mat-table {
  width: 100%;
}
.csm-report .table-container .mat-column-select {
  flex: 0 0 50px;
  padding-left: 20px;
}
/*# sourceMappingURL=csm-report.component.css.map */
